export const authServerConstants = {
    
    USE_AUTH_SERVER: 'USE_AUTH_SERVER',
    AUTH_SERVER_EXIT_URL: 'AUTH_SERVER_EXIT_URL',
    IS_AUTH_SERVER_ADMIN_LOGIN: 'IS_AUTH_SERVER_ADMIN_LOGIN',
    
    ADMIN_LOGOUT: 'adminLogout'
};